import {
  IconBuildingBridge,
  IconHexagons,
  IconMapPin,
  IconTarget,
  IconWash,
} from '@tabler/icons-react';

export const SuggestedSudsIcons = {
  'Detention basin': <IconWash size={16} />,
  'Green roof': <IconTarget size={16} />,
  Swale: <IconBuildingBridge size={16} />,
  'Rain garden': <IconHexagons size={16} />,
  default: <IconMapPin size={16} />,
};
